import {AbstractDictionaryViewModel} from "./abstract-dictionary.view-model";
import {CountryApiModel} from "../../api/models/country.api-model";

export class CountryViewModel extends AbstractDictionaryViewModel<CountryApiModel> {
  public code: string;

  constructor(protected apiModel: CountryApiModel) {
    super(apiModel);
    this.code = apiModel.code;
  }
}
